module.exports = "<!-- <span style='display:block;font-size:30px;padding:20px 0px;'>Schemes</span> -->\n<app-schemes-menu></app-schemes-menu>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/schemes/schemes.component.html
// module id = ./src/app/schemes/schemes.component.html
// module chunks = main